import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Box,
  Paper,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
// components
import { TrainingProgramsListHead, TrainingProgramsListToolbar, TrainingProgramsMoreMenu } from '../sections/reports';

import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  
  { id: 'month', label: 'Month', alignRight: false },
  { id: 'year', label: 'Year', alignRight: false },
  { id: 'training', label: 'Training', alignRight: false },
  { id: 'material', label: 'Material', alignRight: false },
  { id: 'form', label: 'Form', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((trainingPrograms) => {
      if (
        trainingPrograms.month.toLowerCase().includes(query.toLowerCase()) ||
        trainingPrograms.year.toString().includes(query) ||
        trainingPrograms.training.toLowerCase().includes(query.toLowerCase()) ||
        trainingPrograms.material.toLowerCase().includes(query.toLowerCase())
      ) {
        return trainingPrograms;
      }
      return null;
    });
  }

  // Apply role filter
  if (roleFilter) {
    filteredArray = filteredArray.filter(
      (trainingPrograms) => trainingPrograms.role.toLowerCase() === roleFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function TrainingPrograms() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('email'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for trainingProgramss
  const [trainingProgram, setTrainingProgram] = useState([]);
  const [editingtrainingProgramsId, setEditingtrainingProgramsId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [training, setTraining] = useState('');
  const [material, setMaterial] = useState('');
    const [form, setForms] = useState([]);
  const [newFormLink, setNewFormLink] = useState('');
  const [selectedtrainingPrograms, setSelectedtrainingPrograms] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);

  // Fetch training programs function
  const fetchtrainingProgramss = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/trainingPrograms');
      console.log('Fetched training programs:', response.data);
      setTrainingProgram(response.data);
    } catch (error) {
      console.error('Error fetching trainingPrograms:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  };

  // Fetch training programs on component mount
  useEffect(() => {
    fetchtrainingProgramss();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = trainingProgram.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing trainingPrograms
  const handleOpenModal = (trainingProgramsId) => {
    if (trainingProgramsId) {
      const trainingProgramstoEdit = trainingProgram.find(
        (trainingPrograms) => trainingPrograms._id === trainingProgramsId
      );
      if (trainingProgramstoEdit) {
        
        setMonth(trainingProgramstoEdit.month);
        setYear(trainingProgramstoEdit.year);
        setTraining(trainingProgramstoEdit.training);
        setMaterial(trainingProgramstoEdit.material);
setForms(trainingProgramstoEdit.form || []);
        setEditingtrainingProgramsId(trainingProgramsId);
      }
    } else {
      
      setMonth('');
      setYear('');
      setTraining('');
      setMaterial('');
        setForms([]);

      setEditingtrainingProgramsId(null);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    
    setMonth('');
    setYear('');
    setTraining('');
    setMaterial('');
    setEditingtrainingProgramsId(null);
  };

    const handleAddFormLink = () => {
    if (newFormLink.trim() !== '') {
      setForms([...form, newFormLink]);
      setNewFormLink('');
    }
  };

  const handleRemoveFormLink = (index) => {
    const updated = [...form];
    updated.splice(index, 1);
    setForms(updated);
  };

  // Handle adding a new trainingPrograms
  const handleAddtrainingPrograms = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/trainingPrograms', {
       
        
        month,
        year,
        training,
        material,
        form
      });

      fetchtrainingProgramss();
      handleCloseModal();
    } catch (error) {
      console.error('Error adding trainingPrograms:', error);
    }
  };

  // Handle updating a trainingPrograms
  const handleUpdatetrainingPrograms = async () => {
    try {
      await axios.put(`https://cpccbe.org/api/trainingPrograms/${editingtrainingProgramsId}`, {
      
        
        month,
        year,
        training,
        material,
        form, // Assuming you have a state variable for the form link
      });
      fetchtrainingProgramss();
      handleCloseModal();
    } catch (error) {
      console.error('Error updating trainingPrograms:', error);
    }
  };

  // Handle deleting a trainingPrograms
  const handleDeletetrainingPrograms = async (trainingProgramsId) => {
    if (window.confirm('Are you sure you want to delete this trainingPrograms?')) {
      try {
        await axios.delete(`https://cpccbe.org/api/trainingPrograms/${trainingProgramsId}`); // Adjust endpoint as necessary
        fetchtrainingProgramss(); // Refresh trainingPrograms list after deletion
      } catch (error) {
        console.error('Error deleting trainingPrograms:', error);
      }
    }
  };

  const handleViewtrainingPrograms = (trainingPrograms) => {
    // Open a modal or set state to display trainingPrograms details
    setSelectedtrainingPrograms(trainingPrograms); // Assuming you have state to hold selected trainingPrograms data
    setViewModalOpen(true); // Open the modal for viewing trainingPrograms details
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - trainingProgram.length) : 0;

  // Apply sorting and filtering
  const filteredtrainingProgramss = applySortFilter(
    trainingProgram,
    getComparator(order, orderBy),
    filterName,
    roleFilter
  );

  const istrainingProgramsNotFound = filteredtrainingProgramss.length === 0;

  return (
    <Page title="trainingPrograms">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Training Programs
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Training Programs
          </Button>
        </Stack>

        <Card>
          <TrainingProgramsListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TrainingProgramsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={trainingProgram.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredtrainingProgramss.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, month, year, training, material } = row;
                    const isItemSelected = selected.indexOf(month) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <IconButton
                            onClick={() => handleViewtrainingPrograms(row)}
                            aria-label="view trainingPrograms"
                          >
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>
                        
                      
                        <TableCell align="left">{month}</TableCell>
                        <TableCell align="left">{year}</TableCell>
                        <TableCell align="left">{training}</TableCell>
                        <TableCell align="left">{material}</TableCell>
<TableCell align="left">
  {Array.isArray(row.form) && row.form.length > 0 ? (
    row.form.map((f, i) => (
      <Typography key={i} variant="caption" display="block">
        <a href={f} target="_blank" rel="noopener noreferrer">
          {f}
        </a>
      </Typography>
    ))
  ) : (
    <Typography variant="caption" color="text.secondary">
      -
    </Typography>
  )}
</TableCell>
                        <TableCell align="left">
                          <TrainingProgramsMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeletetrainingPrograms(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {istrainingProgramsNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={trainingProgram.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Adding/Editing Training Programs */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingtrainingProgramsId ? 'Edit Training Program' : 'Add New Training Program'}</DialogTitle>
          <DialogContent>
            
            <TextField
              margin="dense"
              id="month"
              label="Month"
              type="text"
              fullWidth
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="training"
              label="Training"
              type="text"
              fullWidth
              value={training}
              onChange={(e) => setTraining(e.target.value)}
            />
            <TextField
              margin="dense"
              id="material"
              label="Material"
              type="text"
              fullWidth
              value={material}
              onChange={(e) => setMaterial(e.target.value)}
            />
                        <Box sx={{ mt: 2 }}>
              <TextField
                label="Add Form Link"
                fullWidth
                value={newFormLink}
                onChange={(e) => setNewFormLink(e.target.value)}
              />
              <Button variant="outlined" onClick={handleAddFormLink} sx={{ mt: 1 }}>
                Add Form
              </Button>
            </Box>

            <Box sx={{ mt: 2 }}>
{Array.isArray(form) && form.map((f, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="body2">{f}</Typography>
                  <IconButton onClick={() => handleRemoveFormLink(index)}>
                    <Iconify icon="eva:trash-2-outline" />
                  </IconButton>
                </Box>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingtrainingProgramsId ? (
              <Button onClick={handleUpdatetrainingPrograms}>Update</Button>
            ) : (
              <Button onClick={handleAddtrainingPrograms}>Add</Button>
            )}
          </DialogActions>
        </Dialog>

        {/* Modal for Viewing Training Program Details */}
        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>Training Program Details</DialogTitle>
          <DialogContent>
          
            <TextField
              margin="dense"
              id="view-month"
              label="Month"
              type="text"
              fullWidth
              value={selectedtrainingPrograms?.month}
              disabled
            />
            <TextField
              margin="dense"
              id="view-year"
              label="Year"
              type="text"
              fullWidth
              value={selectedtrainingPrograms?.year}
              disabled
            />
            <TextField
              margin="dense"
              id="view-training"
              label="Training"
              type="text"
              fullWidth
              value={selectedtrainingPrograms?.training}
              disabled
            />
            <TextField
              margin="dense"
              id="view-material"
              label="Material"
              type="text"
              fullWidth
              value={selectedtrainingPrograms?.material}
              disabled
            />
                            <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">Forms:</Typography>
{Array.isArray(selectedtrainingPrograms?.form) ? selectedtrainingPrograms.form.map((f, i) => (
                    <Typography key={i} variant="body2">
                      <a href={f} target="_blank" rel="noopener noreferrer">{f}</a>
                    </Typography>
                  )) : (
                    <Typography variant="body2">
                     <a href={selectedtrainingPrograms?.form} target="_blank" rel="noopener noreferrer">
  {selectedtrainingPrograms?.form}
</a>
                    </Typography>
                  )}
                </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
